let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ibdXP")).then(() => parcelRequire('gcK5c'));